var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Hero'),_c('Assignment'),_c('Register',{attrs:{"id":"register","submissions":_vm.allowSubmissions}}),(_vm.allowSubmissions)?_c('Leaderboard'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }